import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Models } from '../../models/global.models';
import { LoanOfficerInformationLeadStore } from './loan-officer-lead.store';

@Injectable({ providedIn: 'root' })
export class LoanOfficerInformationLeadQuery extends Query<Models.LoanOfficerInformationLeadForm> {
  protected store: LoanOfficerInformationLeadStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(LoanOfficerInformationLeadStore);

    super(store);

    this.store = store;
  }
}
